import React from 'react';
import PropTypes from 'prop-types';
import { PieChart, Pie, Cell, Legend, ResponsiveContainer, Label } from 'recharts';

import './donut-chart.scss';

const COLORS = [
  '#FF0000',
  '#00B0CA',
  '#C88FCA',
  '#E60000',
  '#007E92',
  '#5E2750',
  '#BD0000',
  '#005765',
  '#990000',
];
const EMPTY_DEFAULT = [
  {
    value: 100,
    name: 'No data',
    notInLegend: true,
  },
];

const renderCusomizedLegend = (props) => {
  const { payload } = props;

  return (
    <div className="customized-legend">
      {payload.map((entry, index) => {
        let { value, color } = entry;

        return entry.payload.notInLegend || entry.payload.value <= 0 ? (
          ''
        ) : (
          <div className="custom-legend-entry" key={index}>
            <div className="">
              <span className="legend-symbol-icon" style={{ backgroundColor: color }}></span>
            </div>
            <div>
              <div className="legend-title">{value}</div>
              <div className="legend-subtitle">{`${props.valuePrefix} ${props.formatter(
                entry.payload.value,
              )}`}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

function CenterLabel({ viewBox, label, sublabel }) {
  const { cx, cy } = viewBox;
  return (
    <>
      <text
        x={cx}
        y={cy - (sublabel ? 15 : 0)}
        className="label"
        textAnchor="middle"
        dominantBaseline="central"
      >
        <tspan alignmentBaseline="middle" fontSize="22">
          {label}
        </tspan>
      </text>
      {sublabel && (
        <text
          x={cx}
          y={cy + 15}
          className="sublabel"
          textAnchor="middle"
          dominantBaseline="central"
        >
          <tspan fontSize="14">{sublabel}</tspan>
        </text>
      )}
    </>
  );
}

export default function DonutChartComponent(props) {
  return (
    <div
      className={`DonutChartComponent ${props.className || ''}`}
      data-testid="DonutChartComponent"
    >
      <ResponsiveContainer height={props.isMobile ? 400 : 300}>
        <PieChart>
          <Pie
            isAnimationActive={false}
            dataKey="value"
            data={
              props.chartData.length > 0 && props.chartData.some((data) => data.value > 0)
                ? props.chartData
                : EMPTY_DEFAULT
            }
            innerRadius={props.maxRadius - 10}
            outerRadius={props.maxRadius}
            fill="#8884d8"
            stroke="none"
            paddingAngle={0}
          >
            {props.chartData.map((entry, index) => (
              <Cell
                key={`chart-data-${index}`}
                dataKey={`chart-data-${index}`}
                fill={COLORS[index % COLORS.length]}
              />
            ))}
          </Pie>

          <Pie
            data={[{ value: 100, notInLegend: true }]}
            dataKey="value"
            outerRadius={props.maxRadius - 5}
            fill="#141827"
            fillOpacity="0.6"
            isAnimationActive={false}
            stroke="none"
          >
            <Label
              content={<CenterLabel label={props.chartLabel} sublabel={props.chartSubLabel} />}
            />
          </Pie>

          {props.isMobile ? (
            <Legend
              className="legend"
              verticalAlign="bottom"
              align="left"
              iconType="circle"
              valuePrefix={props.valuePrefix}
              content={renderCusomizedLegend}
              formatter={props.formatter}
            />
          ) : (
            <Legend
              className="legend"
              verticalAlign="middle"
              layout="vertical"
              align="right"
              iconType="circle"
              valuePrefix={props.valuePrefix}
              content={renderCusomizedLegend}
              formatter={props.formatter}
            />
          )}
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
}

DonutChartComponent.propTypes = {
  formatter: PropTypes.func,
  chartData: PropTypes.array,
  valuePrefix: PropTypes.string,
  maxRadius: PropTypes.number,
  className: PropTypes.string,
  chartLabel: PropTypes.string,
  chartSubLabel: PropTypes.string,
  isMobile: PropTypes.bool,
};

DonutChartComponent.defaultProps = {
  formatter: (val) => {
    return val;
  },
  chartData: EMPTY_DEFAULT,
  valuePrefix: '',
  maxRadius: 85,
};
